const families = [
    [
        'revolving-balances',
        'REVOLVING_BALANCE',
        'revolvingBalanceRowSchema',
        'revolvingBalanceDetailsSchema',
        'moneyTotalsSchema',
        'transactionListQuerySchema',
    ],
    [
        'purchases',
        'PURCHASE',
        'purchaseRowSchema',
        'purchaseDetailsSchema',
        'quantityTotalsSchema',
        'purchaseListQuerySchema',
    ],
    [
        'sales',
        'SALE',
        'saleRowSchema',
        'saleDetailsSchema',
        'quantityTotalsSchema',
        'saleListQuerySchema',
    ],
    [
        'debt-movements',
        'DEBT_MOVEMENT',
        'debtMovementRowSchema',
        'debtMovementDetailsSchema',
        'debtTotalsSchema',
        'debtMovementListQuerySchema',
    ],
    [
        'payments',
        'PAYMENT',
        'paymentRowSchema',
        'paymentDetailsSchema',
        'moneyTotalsSchema',
        'transactionListQuerySchema',
    ],
    [
        'receipts',
        'RECEIPT',
        'receiptRowSchema',
        'receiptDetailsSchema',
        'moneyTotalsSchema',
        'transactionListQuerySchema',
    ],
];
const familyEndpoints = families.flatMap(([path, entity, row, details, totals, query]) => [
    {
        method: 'GET',
        path: `/${path}`,
        app: 'DASHBOARD',
        service: `${entity}_LIST`,
        request: query,
        response: `listResponse(${row}, ${totals})`,
        tests: ['FU-32', 'FU-33', 'FU-34'],
    },
    {
        method: 'GET',
        path: `/${path}/export`,
        app: 'DASHBOARD',
        service: `${entity}_EXPORT`,
        request: `${query} + lang=ar|en`,
        response: 'xlsx file',
        tests: ['FU-36', 'FU-38'],
    },
    {
        method: 'GET',
        path: `/${path}/:id`,
        app: 'DASHBOARD',
        service: `${entity}_VIEW`,
        response: details,
        tests: ['FU-20', 'FU-71'],
    },
    {
        method: 'DELETE',
        path: `/${path}/:id`,
        app: 'DASHBOARD',
        service: `${entity}_DELETE`,
        response: 'empty (204)',
        tests: ['FU-13'],
    },
    {
        method: 'POST',
        path: `/${path}/delete-many`,
        app: 'DASHBOARD',
        service: `${entity}_DELETE`,
        request: 'deleteManySchema',
        response: '{ deleted: number }',
        tests: ['FU-13'],
    },
]);
const operatorCreate = (path, service, request, tests) => ({
    method: 'POST',
    path: `/operator/${path}`,
    app: 'OPERATOR',
    service,
    request,
    response: 'operationResultSchema',
    tests,
});
export const FUEL_ENDPOINTS = [
    // --- session (both apps) ---
    {
        method: 'POST',
        path: '/auth/:app/launch',
        app: 'PUBLIC',
        service: null,
        request: 'launchSchema',
        response: 'sessionResponseSchema',
        tests: ['SH-15', 'FU-59'],
    },
    {
        method: 'GET',
        path: '/auth/:app/me',
        app: 'ANY',
        service: null,
        response: 'sessionResponseSchema',
        tests: ['SH-18'],
    },
    {
        method: 'POST',
        path: '/auth/:app/logout',
        app: 'ANY',
        service: null,
        response: 'empty (204)',
        tests: ['SH-18'],
    },
    { method: 'GET', path: '/branches', app: 'ANY', service: null, response: 'branch[]', tests: [] },
    {
        method: 'GET',
        path: '/system/state',
        app: 'ANY',
        service: null,
        response: 'systemStateSchema',
        tests: ['FU-79', 'FU-83'],
    },
    // --- operator app (fuel.md section 4) ---
    {
        method: 'GET',
        path: '/operator/context',
        app: 'OPERATOR',
        service: null,
        response: 'operatorContextSchema',
        tests: ['FU-05', 'FU-27', 'FU-31'],
    },
    {
        method: 'GET',
        path: '/operator/debtors',
        app: 'OPERATOR',
        service: ['OPERATOR_DEBT_SALE_CREATE', 'OPERATOR_DEBT_REPAYMENT_CREATE'],
        request: 'operatorDebtorQuerySchema',
        response: 'operatorDebtorOptionSchema[]',
        tests: ['FU-07'],
    },
    {
        method: 'GET',
        path: '/operator/transactions/lookup',
        app: 'OPERATOR',
        service: [
            'OPERATOR_REVOLVING_BALANCE_CREATE',
            'OPERATOR_PURCHASE_CREATE',
            'OPERATOR_SALE_CREATE',
            'OPERATOR_DEBT_SALE_CREATE',
            'OPERATOR_DEBT_REPAYMENT_CREATE',
            'OPERATOR_PAYMENT_CREATE',
            'OPERATOR_RECEIPT_CREATE',
            'OPERATOR_SHIFT_CLOSE',
            'OPERATOR_PURCHASE_PRICE_COMPLETE',
            'OPERATOR_SALE_PRICE_COMPLETE',
            'OPERATOR_TRANSACTION_DELIVER',
        ],
        request: 'operatorLookupQuerySchema',
        response: 'operatorLookupSchema',
        tests: ['FU-130', 'FU-131', 'FU-132'],
    },
    {
        method: 'POST',
        path: '/operator/transactions/:reference/complete-price',
        app: 'OPERATOR',
        // A PDA purchase needs the purchase service and a PDA sale the sale service (KAN-37).
        service: ['OPERATOR_PURCHASE_PRICE_COMPLETE', 'OPERATOR_SALE_PRICE_COMPLETE'],
        request: 'operatorCompletePriceSchema',
        response: 'operatorLookupSchema',
        tests: ['FU-133', 'FU-134', 'FU-139'],
    },
    {
        method: 'POST',
        path: '/operator/transactions/:reference/deliver',
        app: 'OPERATOR',
        service: 'OPERATOR_TRANSACTION_DELIVER',
        request: 'operatorDeliverSchema',
        response: 'operatorLookupSchema',
        tests: ['FU-133', 'FU-134'],
    },
    operatorCreate('revolving-balances', 'OPERATOR_REVOLVING_BALANCE_CREATE', 'createRevolvingBalanceSchema', ['FU-19']),
    operatorCreate('purchases', 'OPERATOR_PURCHASE_CREATE', 'createPurchaseSchema', [
        'FU-01',
        'FU-02',
        'FU-03',
        'FU-05',
        'FU-21',
    ]),
    operatorCreate('sales', 'OPERATOR_SALE_CREATE', 'createSaleSchema', [
        'FU-05',
        'FU-21',
        'FU-67',
        'FU-72',
    ]),
    operatorCreate('debt-sales', 'OPERATOR_DEBT_SALE_CREATE', 'createDebtSaleSchema', [
        'FU-07',
        'FU-09',
        'FU-18',
        'FU-22',
        'FU-50',
        'FU-67',
    ]),
    operatorCreate('debt-repayments', 'OPERATOR_DEBT_REPAYMENT_CREATE', 'createDebtRepaymentSchema', [
        'FU-08',
        'FU-10',
        'FU-22',
        'FU-50',
    ]),
    operatorCreate('payments', 'OPERATOR_PAYMENT_CREATE', 'createPaymentSchema', ['FU-10', 'FU-23']),
    operatorCreate('receipts', 'OPERATOR_RECEIPT_CREATE', 'createReceiptSchema', ['FU-10', 'FU-23']),
    {
        method: 'POST',
        path: '/operator/shift-close',
        app: 'OPERATOR',
        service: 'OPERATOR_SHIFT_CLOSE',
        request: 'shiftCloseSchema',
        response: 'shiftCloseResultSchema',
        tests: ['FU-28', 'FU-29', 'FU-30'],
    },
    // --- PDA app (fuel-pda.md section 5); every route also needs the product's access service ---
    {
        method: 'GET',
        path: '/pda/context',
        app: 'PDA',
        service: [
            'PDA_PURCHASE_CREATE',
            'PDA_SALE_CREATE',
            'PDA_DELIVERY_COMPLETE',
            'PDA_RECEIPT_REPRINT',
        ],
        response: 'pdaContextSchema',
        tests: ['PDA-10', 'PDA-22'],
    },
    {
        method: 'GET',
        path: '/pda/nationalities',
        app: 'PDA',
        service: ['PDA_PURCHASE_CREATE', 'PDA_SALE_CREATE'],
        response: 'nationalityRefSchema[]',
        tests: ['PDA-06', 'PDA-21'],
    },
    {
        method: 'GET',
        path: '/pda/customers',
        app: 'PDA',
        service: ['PDA_PURCHASE_CREATE', 'PDA_SALE_CREATE'],
        request: 'pdaCustomerLookupQuerySchema',
        response: 'pdaCustomerLookupSchema',
        tests: ['PDA-05'],
    },
    {
        method: 'POST',
        path: '/pda/purchases',
        app: 'PDA',
        service: 'PDA_PURCHASE_CREATE',
        request: 'createPdaPurchaseSchema',
        response: 'pdaReceiptSchema',
        tests: ['PDA-01', 'PDA-02', 'PDA-03', 'PDA-04', 'PDA-07', 'PDA-08', 'PDA-09', 'PDA-10'],
    },
    {
        method: 'POST',
        path: '/pda/sales',
        app: 'PDA',
        service: 'PDA_SALE_CREATE',
        request: 'createPdaSaleSchema',
        response: 'pdaReceiptSchema',
        tests: ['PDA-37', 'PDA-38'],
    },
    {
        method: 'GET',
        path: '/pda/sales/:reference/receipt',
        app: 'PDA',
        service: ['PDA_RECEIPT_REPRINT', 'PDA_SALE_CREATE'],
        response: 'pdaReceiptSchema',
        tests: ['PDA-38'],
    },
    {
        method: 'GET',
        path: '/pda/purchases/recent',
        app: 'PDA',
        service: 'PDA_RECEIPT_REPRINT',
        response: 'pdaRecentPurchaseSchema[]',
        tests: ['PDA-13'],
    },
    {
        method: 'GET',
        path: '/pda/purchases/:reference/receipt',
        app: 'PDA',
        service: ['PDA_RECEIPT_REPRINT', 'PDA_PURCHASE_CREATE'],
        response: 'pdaReceiptSchema',
        tests: ['PDA-11', 'PDA-13'],
    },
    {
        method: 'POST',
        path: '/pda/purchases/:reference/whatsapp',
        app: 'PDA',
        service: ['PDA_RECEIPT_REPRINT', 'PDA_PURCHASE_CREATE'],
        response: 'pdaWhatsappResultSchema',
        tests: ['PDA-14'],
    },
    {
        method: 'GET',
        path: '/pda/deliveries/:reference',
        app: 'PDA',
        service: 'PDA_DELIVERY_COMPLETE',
        response: 'pdaDeliveryLookupSchema',
        tests: ['PDA-15', 'PDA-16'],
    },
    {
        method: 'POST',
        path: '/pda/deliveries/:reference/complete',
        app: 'PDA',
        service: 'PDA_DELIVERY_COMPLETE',
        response: 'pdaDeliveryResultSchema',
        tests: ['PDA-16', 'PDA-17', 'PDA-18'],
    },
    // --- PDA offline mode (fuel-pda.md section 13) ---
    {
        method: 'GET',
        path: '/pda/sync/pull',
        app: 'PDA',
        service: ['PDA_PURCHASE_CREATE', 'PDA_DELIVERY_COMPLETE', 'PDA_RECEIPT_REPRINT'],
        request: 'pdaSyncPullQuerySchema',
        response: 'pdaSyncPullSchema',
        tests: ['PDA-52', 'PDA-57'],
    },
    {
        method: 'POST',
        path: '/pda/sync/push',
        app: 'PDA',
        service: ['PDA_PURCHASE_CREATE', 'PDA_DELIVERY_COMPLETE', 'PDA_RECEIPT_REPRINT'],
        request: 'pdaSyncPushSchema',
        response: 'pdaSyncPushResultSchema',
        tests: ['PDA-54', 'PDA-55', 'PDA-56'],
    },
    {
        method: 'GET',
        path: '/pda-sync-conflicts',
        app: 'DASHBOARD',
        service: ['PURCHASE_LIST', 'SALE_LIST'],
        request: 'pdaSyncConflictListQuerySchema',
        response: 'paginated(pdaSyncConflictRowSchema)',
        tests: ['PDA-67'],
    },
    {
        method: 'POST',
        path: '/pda-sync-conflicts/:id/resolve',
        app: 'DASHBOARD',
        service: ['PURCHASE_LIST', 'SALE_LIST'],
        response: 'pdaSyncConflictRowSchema',
        tests: ['PDA-67'],
    },
    // --- dashboard: PDA purchases, purchase customers and nationalities (fuel-pda.md section 6) ---
    {
        method: 'GET',
        path: '/purchases/price-defaults',
        app: 'DASHBOARD',
        service: 'PURCHASE_PRICE_COMPLETE',
        response: 'purchasePriceDefaultsSchema',
        tests: ['PDA-19'],
    },
    {
        method: 'POST',
        path: '/purchases/:id/complete-price',
        app: 'DASHBOARD',
        service: 'PURCHASE_PRICE_COMPLETE',
        request: 'completePurchasePriceSchema',
        response: 'purchaseDetailsSchema',
        tests: ['PDA-19'],
    },
    {
        method: 'GET',
        path: '/pda-customers',
        app: 'DASHBOARD',
        service: 'PDA_CUSTOMER_LIST',
        request: 'pdaCustomerListQuerySchema',
        response: 'paginated(pdaCustomerRowSchema)',
        tests: ['PDA-21'],
    },
    {
        method: 'GET',
        path: '/pda-customers/:id',
        app: 'DASHBOARD',
        service: 'PDA_CUSTOMER_VIEW',
        response: 'pdaCustomerRowSchema',
        tests: ['PDA-21'],
    },
    {
        method: 'PATCH',
        path: '/pda-customers/:id',
        app: 'DASHBOARD',
        service: 'PDA_CUSTOMER_UPDATE',
        request: 'updatePdaCustomerSchema',
        response: 'pdaCustomerRowSchema',
        tests: ['PDA-21'],
    },
    {
        method: 'GET',
        path: '/nationalities',
        app: 'DASHBOARD',
        service: 'NATIONALITY_LIST',
        response: 'nationalityRowSchema[]',
        tests: ['PDA-21'],
    },
    {
        method: 'POST',
        path: '/nationalities',
        app: 'DASHBOARD',
        service: 'NATIONALITY_CREATE',
        request: 'saveNationalitySchema',
        response: 'nationalityRowSchema',
        tests: ['PDA-21'],
    },
    {
        method: 'PATCH',
        path: '/nationalities/:id',
        app: 'DASHBOARD',
        service: 'NATIONALITY_UPDATE',
        request: 'saveNationalitySchema',
        response: 'nationalityRowSchema',
        tests: ['PDA-21'],
    },
    {
        method: 'DELETE',
        path: '/nationalities/:id',
        app: 'DASHBOARD',
        service: 'NATIONALITY_DELETE',
        response: 'empty (204)',
        tests: ['PDA-21'],
    },
    {
        method: 'GET',
        path: '/lookups/nationalities',
        app: 'DASHBOARD',
        service: ['PDA_CUSTOMER_UPDATE', 'NATIONALITY_LIST'],
        response: 'nationalityRefSchema[]',
        tests: ['PDA-21'],
    },
    // --- dashboard: overview and transaction lists ---
    {
        method: 'POST',
        path: '/overview',
        app: 'DASHBOARD',
        service: 'DASHBOARD_VIEW',
        request: 'overviewRequestSchema',
        response: 'overviewSchema',
        tests: ['FU-57', 'FU-98'],
    },
    ...familyEndpoints,
    {
        method: 'GET',
        path: '/debt-movements/manual-lookup',
        app: 'DASHBOARD',
        service: ['DEBT_MOVEMENT_MANUAL_CREATE', 'DEBT_MOVEMENT_UPDATE'],
        response: 'manualDebtLookupSchema',
        tests: ['FU-11', 'FU-15'],
    },
    {
        method: 'GET',
        path: '/debt-movements/pdf',
        app: 'DASHBOARD',
        service: 'DEBT_MOVEMENT_EXPORT',
        request: 'debtMovementListQuerySchema',
        response: 'pdf file',
        tests: ['FU-37', 'FU-97'],
    },
    {
        method: 'POST',
        path: '/debt-movements',
        app: 'DASHBOARD',
        service: 'DEBT_MOVEMENT_MANUAL_CREATE',
        request: 'createManualDebtMovementSchema',
        response: 'debtMovementDetailsSchema',
        tests: ['FU-11', 'FU-12'],
    },
    {
        method: 'PATCH',
        path: '/debt-movements/:id',
        app: 'DASHBOARD',
        service: 'DEBT_MOVEMENT_UPDATE',
        request: 'updateDebtMovementSchema',
        response: 'debtMovementDetailsSchema',
        tests: ['FU-15', 'FU-16', 'FU-48'],
    },
    {
        method: 'POST',
        path: '/sales/:id/deliver',
        app: 'DASHBOARD',
        service: 'SALE_DELIVER',
        response: 'deliveryResultSchema',
        tests: ['FU-68', 'FU-69'],
    },
    {
        method: 'POST',
        path: '/debt-movements/:id/deliver',
        app: 'DASHBOARD',
        service: 'DEBT_MOVEMENT_DELIVER',
        response: 'deliveryResultSchema',
        tests: ['FU-68', 'FU-69'],
    },
    // --- messages (fuel.md section 10) ---
    {
        method: 'POST',
        path: '/messages/:id/retry',
        app: 'DASHBOARD',
        service: 'MESSAGE_RETRY',
        response: 'messageRowSchema',
        tests: ['FU-73'],
    },
    {
        method: 'POST',
        path: '/messages/bulk',
        app: 'DASHBOARD',
        service: 'MESSAGE_SEND',
        request: 'sendMessageSchema',
        response: 'bulkMessageResultSchema',
        tests: ['FU-52'],
    },
    // --- debtors and vehicles (fuel.md section 5.4) ---
    {
        method: 'GET',
        path: '/debtors',
        app: 'DASHBOARD',
        service: 'DEBTOR_LIST',
        request: 'debtorListQuerySchema',
        response: 'listResponse(debtorRowSchema, moneyTotalsSchema)',
        tests: ['FU-40', 'FU-43', 'FU-44'],
    },
    {
        method: 'GET',
        path: '/debtors/:id',
        app: 'DASHBOARD',
        service: 'DEBTOR_VIEW',
        response: 'debtorRowSchema',
        tests: ['FU-40'],
    },
    {
        method: 'POST',
        path: '/debtors',
        app: 'DASHBOARD',
        service: 'DEBTOR_CREATE',
        request: 'saveDebtorSchema',
        response: 'debtorRowSchema',
        tests: ['FU-40', 'FU-41', 'FU-45'],
    },
    {
        method: 'PATCH',
        path: '/debtors/:id',
        app: 'DASHBOARD',
        service: 'DEBTOR_UPDATE',
        request: 'saveDebtorSchema',
        response: 'debtorRowSchema',
        tests: ['FU-40', 'FU-45'],
    },
    {
        method: 'DELETE',
        path: '/debtors/:id',
        app: 'DASHBOARD',
        service: 'DEBTOR_DELETE',
        response: 'empty (204)',
        tests: ['FU-40'],
    },
    {
        method: 'POST',
        path: '/debtors/:id/adjust-balance',
        app: 'DASHBOARD',
        service: 'DEBTOR_BALANCE_ADJUST',
        request: 'adjustDebtorBalanceSchema',
        response: 'debtorRowSchema',
        tests: ['FU-17'],
    },
    {
        method: 'GET',
        path: '/debtors/:id/vehicles',
        app: 'DASHBOARD',
        service: 'DEBTOR_VIEW',
        response: 'vehicleRowSchema[]',
        tests: ['FU-42'],
    },
    {
        method: 'POST',
        path: '/debtors/:id/vehicles',
        app: 'DASHBOARD',
        service: 'DEBTOR_UPDATE',
        request: 'createVehicleSchema',
        response: 'vehicleRowSchema',
        tests: ['FU-42'],
    },
    {
        method: 'DELETE',
        path: '/debtors/:id/vehicles/:vehicleId',
        app: 'DASHBOARD',
        service: 'DEBTOR_UPDATE',
        response: 'empty (204)',
        tests: ['FU-42'],
    },
    // --- look-ups for filters and drawers (any dashboard list service) ---
    {
        method: 'GET',
        path: '/lookups/debtors',
        app: 'DASHBOARD',
        service: ['DEBT_MOVEMENT_LIST', 'DEBTOR_LIST', 'MESSAGE_SEND'],
        request: 'debtorLookupQuerySchema',
        response: 'debtorOptionSchema[]',
        tests: [],
    },
    {
        method: 'GET',
        path: '/lookups/vehicles',
        app: 'DASHBOARD',
        service: ['DEBT_MOVEMENT_LIST', 'DEBTOR_LIST'],
        request: 'vehicleLookupQuerySchema',
        response: 'vehicleOptionSchema[]',
        tests: [],
    },
    {
        method: 'GET',
        path: '/lookups/employees',
        app: 'DASHBOARD',
        service: 'MOVEMENT_HISTORY_VIEW',
        request: 'lookupQuerySchema',
        response: 'employeeOptionSchema[]',
        tests: ['FU-70'],
    },
    // --- inventory count mode and pending transactions (fuel.md sections 4.4 and 5.12) ---
    {
        method: 'GET',
        path: '/inventory-mode',
        app: 'DASHBOARD',
        service: ['PENDING_TRANSACTION_LIST', 'INVENTORY_MODE_MANAGE'],
        response: 'inventoryModesSchema',
        tests: ['FIC-02'],
    },
    {
        method: 'PUT',
        path: '/inventory-mode',
        app: 'DASHBOARD',
        service: 'INVENTORY_MODE_MANAGE',
        request: 'setInventoryModeSchema',
        response: 'inventoryModeStatusSchema',
        tests: ['FIC-02', 'FIC-14'],
    },
    {
        method: 'GET',
        path: '/pending-transactions',
        app: 'DASHBOARD',
        service: 'PENDING_TRANSACTION_LIST',
        request: 'pendingTransactionListQuerySchema',
        response: 'pendingTransactionListSchema',
        tests: ['FIC-06', 'FIC-14', 'FIC-30'],
    },
    {
        method: 'GET',
        path: '/pending-transactions/:type/:id/post-preview',
        app: 'DASHBOARD',
        service: 'PENDING_TRANSACTION_POST',
        response: 'postPreviewSchema',
        tests: ['FIC-15', 'FIC-30'],
    },
    {
        method: 'POST',
        path: '/pending-transactions/:type/:id/post',
        app: 'DASHBOARD',
        service: 'PENDING_TRANSACTION_POST',
        request: 'postTransactionSchema',
        response: 'postTransactionResultSchema',
        tests: ['FIC-07', 'FIC-08', 'FIC-09', 'FIC-16'],
    },
    {
        method: 'POST',
        path: '/pending-transactions/post-preview',
        app: 'DASHBOARD',
        service: 'PENDING_TRANSACTION_POST',
        request: 'bulkPostPreviewInputSchema',
        response: 'bulkPostPreviewSchema',
        tests: ['FIC-31'],
    },
    {
        method: 'POST',
        path: '/pending-transactions/post',
        app: 'DASHBOARD',
        service: 'PENDING_TRANSACTION_POST',
        request: 'bulkPostInputSchema',
        response: 'bulkPostResultSchema',
        tests: ['FIC-32'],
    },
    // --- closes, trash ---
    {
        method: 'GET',
        path: '/closes',
        app: 'DASHBOARD',
        service: 'CLOSE_LIST',
        request: 'closeListQuerySchema',
        response: 'listResponse(closeRowSchema, null)',
        tests: ['FU-29'],
    },
    {
        method: 'GET',
        path: '/trash',
        app: 'DASHBOARD',
        service: 'TRASH_LIST',
        request: 'trashListQuerySchema',
        response: 'paginated(trashRowSchema)',
        tests: ['FU-54'],
    },
    {
        method: 'POST',
        path: '/trash/:type/:id/restore',
        app: 'DASHBOARD',
        service: 'TRASH_RESTORE',
        response: 'trashRowSchema',
        tests: ['FU-14', 'FU-54'],
    },
    {
        method: 'DELETE',
        path: '/trash/:type/:id',
        app: 'DASHBOARD',
        service: 'TRASH_DELETE',
        response: 'empty (204)',
        tests: ['FU-87'],
    },
    // --- categories and settings ---
    {
        method: 'GET',
        path: '/categories',
        app: 'DASHBOARD',
        service: 'CATEGORY_LIST',
        response: 'categoryRowSchema[]',
        tests: ['FU-56'],
    },
    {
        method: 'POST',
        path: '/categories',
        app: 'DASHBOARD',
        service: 'CATEGORY_CREATE',
        request: 'createCategorySchema',
        response: 'categoryRowSchema',
        tests: ['FU-56'],
    },
    {
        method: 'DELETE',
        path: '/categories/:id',
        app: 'DASHBOARD',
        service: 'CATEGORY_DELETE',
        response: 'empty (204)',
        tests: ['FU-56'],
    },
    {
        method: 'GET',
        path: '/settings',
        app: 'DASHBOARD',
        service: 'SETTINGS_VIEW',
        response: 'settingsSchema',
        tests: ['FU-55'],
    },
    {
        method: 'PUT',
        path: '/settings',
        app: 'DASHBOARD',
        service: 'SETTINGS_UPDATE',
        request: 'updateSettingsSchema',
        response: 'settingsSchema',
        tests: ['FU-06', 'FU-55'],
    },
    // --- users and groups ---
    {
        method: 'GET',
        path: '/users',
        app: 'DASHBOARD',
        service: 'USER_LIST',
        request: 'userListQuerySchema',
        response: 'paginated(userRowSchema)',
        tests: ['SH-07'],
    },
    {
        method: 'GET',
        path: '/users/employee-lookup',
        app: 'DASHBOARD',
        service: 'USER_CREATE',
        request: 'employeeLookupQuerySchema',
        response: 'employeeLookupResultSchema',
        tests: ['SH-16'],
    },
    {
        method: 'GET',
        path: '/users/:id',
        app: 'DASHBOARD',
        service: 'USER_VIEW',
        response: 'userRowSchema',
        tests: [],
    },
    {
        method: 'POST',
        path: '/users',
        app: 'DASHBOARD',
        service: 'USER_CREATE',
        request: 'createUserSchema',
        response: 'createUserResultSchema',
        tests: ['SH-15', 'SH-16', 'FU-61', 'FU-62'],
    },
    {
        method: 'PATCH',
        path: '/users/:id',
        app: 'DASHBOARD',
        service: 'USER_UPDATE',
        request: 'updateUserSchema',
        response: 'userRowSchema',
        tests: ['FU-61', 'FU-62'],
    },
    {
        method: 'POST',
        path: '/users/:id/status',
        app: 'DASHBOARD',
        service: 'USER_CHANGE_STATUS',
        request: 'changeUserStatusSchema',
        response: 'userRowSchema',
        tests: ['SH-11'],
    },
    {
        method: 'POST',
        path: '/users/:id/reset-password',
        app: 'DASHBOARD',
        service: 'USER_RESET_PASSWORD',
        response: 'resetPasswordResultSchema',
        tests: ['SH-11'],
    },
    {
        method: 'DELETE',
        path: '/users/:id',
        app: 'DASHBOARD',
        service: 'USER_DELETE',
        response: 'empty (204)',
        tests: ['SH-17'],
    },
    {
        method: 'GET',
        path: '/services',
        app: 'DASHBOARD',
        service: ['GROUP_VIEW', 'GROUP_SERVICE_MANAGE'],
        response: 'serviceTreeSchema',
        tests: ['SH-08'],
    },
    {
        method: 'GET',
        path: '/groups',
        app: 'DASHBOARD',
        service: ['GROUP_LIST', 'USER_CREATE', 'USER_UPDATE'],
        request: 'groupListQuerySchema',
        response: 'paginated(groupRowSchema)',
        tests: [],
    },
    {
        method: 'GET',
        path: '/groups/:id',
        app: 'DASHBOARD',
        service: 'GROUP_VIEW',
        response: 'groupDetailsSchema',
        tests: [],
    },
    {
        method: 'POST',
        path: '/groups',
        app: 'DASHBOARD',
        service: 'GROUP_CREATE',
        request: 'saveGroupSchema',
        response: 'groupDetailsSchema',
        tests: [],
    },
    {
        method: 'PATCH',
        path: '/groups/:id',
        app: 'DASHBOARD',
        service: 'GROUP_UPDATE',
        request: 'saveGroupSchema',
        response: 'groupDetailsSchema',
        tests: [],
    },
    {
        method: 'POST',
        path: '/groups/:id/status',
        app: 'DASHBOARD',
        service: 'GROUP_CHANGE_STATUS',
        request: 'changeGroupStatusSchema',
        response: 'groupDetailsSchema',
        tests: ['SH-10'],
    },
    {
        method: 'DELETE',
        path: '/groups/:id',
        app: 'DASHBOARD',
        service: 'GROUP_DELETE',
        response: 'empty (204)',
        tests: ['SH-10'],
    },
    {
        method: 'PUT',
        path: '/groups/:id/services',
        app: 'DASHBOARD',
        service: 'GROUP_SERVICE_MANAGE',
        request: 'setGroupServicesSchema',
        response: 'groupDetailsSchema',
        tests: ['SH-09', 'SH-10', 'FU-65'],
    },
    // --- year management (fuel.md section 5.11) ---
    {
        method: 'POST',
        path: '/years/status',
        app: 'DASHBOARD',
        service: 'YEAR_MANAGE',
        request: 'yearPasswordSchema',
        response: 'yearStatusSchema',
        tests: ['FU-76'],
    },
    {
        method: 'POST',
        path: '/years/:year/backup',
        app: 'DASHBOARD',
        service: 'YEAR_MANAGE',
        request: 'yearActionSchema',
        response: 'yearOperationSchema',
        tests: ['FU-77', 'FU-83', 'FU-84'],
    },
    {
        method: 'POST',
        path: '/years/operations/:id/download',
        app: 'DASHBOARD',
        service: 'YEAR_MANAGE',
        request: 'yearPasswordSchema',
        response: 'backup file',
        tests: ['FU-77'],
    },
    {
        method: 'POST',
        path: '/years/:year/archive',
        app: 'DASHBOARD',
        service: 'YEAR_MANAGE',
        request: 'yearActionSchema',
        response: 'yearOperationSchema',
        tests: ['FU-78', 'FU-80', 'FU-84'],
    },
    {
        method: 'POST',
        path: '/years/:year/reset',
        app: 'DASHBOARD',
        service: 'YEAR_MANAGE',
        request: 'yearActionSchema',
        response: 'yearOperationSchema',
        tests: ['FU-81', 'FU-82', 'FU-84'],
    },
];
//# sourceMappingURL=endpoints.js.map